(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["about-testimonials-carousel-content"] && !Shopify.designMode) return;
  try {
    (function initTestimonialsLoop() {
    const tracks = document.querySelectorAll('.about-testimonials-carousel__track');
    if (!tracks.length) return;
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    tracks.forEach((track) => {
      if (track.dataset.loopReady === 'true') return;
      if (mobileQuery.matches) return;

      const originalSlides = Array.from(track.children);
      if (originalSlides.length < 2) return;

      const originalCount = originalSlides.length;
      originalSlides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      const getLoopWidth = () => {
        const gap = parseFloat(window.getComputedStyle(track).columnGap || '0');
        let width = 0;

        for (let i = 0; i < originalCount; i += 1) {
          width += track.children[i].getBoundingClientRect().width;
          if (i < originalCount - 1) width += gap;
        }

        return width;
      };

      let loopWidth = getLoopWidth();
      let rafId = null;
      let lastTs = 0;
      let paused = false;
      const speed = 32; // pixels per second

      const tick = (ts) => {
        if (!lastTs) lastTs = ts;
        const delta = (ts - lastTs) / 1000;
        lastTs = ts;

        if (!paused) {
          track.scrollLeft += speed * delta;
          if (track.scrollLeft >= loopWidth) {
            track.scrollLeft -= loopWidth;
          }
        }

        rafId = window.requestAnimationFrame(tick);
      };

      const resume = () => {
        paused = false;
      };

      const pause = () => {
        paused = true;
      };

      track.addEventListener('mouseenter', pause);
      track.addEventListener('mouseleave', resume);
      track.addEventListener('focusin', pause);
      track.addEventListener('focusout', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', resume);

      window.addEventListener('resize', () => {
        loopWidth = getLoopWidth();
        if (track.scrollLeft >= loopWidth) {
          track.scrollLeft = track.scrollLeft % loopWidth;
        }
      });

      track.dataset.loopReady = 'true';
      rafId = window.requestAnimationFrame(tick);

      // Stop loop when removed from DOM (theme editor section reloads).
      const observer = new MutationObserver(() => {
        if (!document.body.contains(track) && rafId) {
          window.cancelAnimationFrame(rafId);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lesson-access-unlock"] && !Shopify.designMode) return;
  try {
    (function () {
    var config = window.PLRLessonAccess || {};
    var STORAGE_KEY = config.storageKey || 'plr_kickstarter_access';
    var productHandle = config.productHandle || '';
    var loggedInEmail = config.loggedInEmail || '';
    var serverGrantedAccess = config.serverGrantedAccess === true;

    function readAccess() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || data.purchased !== true) return null;
        if (data.expiresAt && Date.now() > data.expiresAt) return null;
        return data;
      } catch (error) {
        return null;
      }
    }

    function normalizeEmail(value) {
      return String(value || '').trim().toLowerCase();
    }

    function saveAccess(email, orderId) {
      if (!email || !productHandle) return;

      try {
        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            email: String(email).trim(),
            productHandle: productHandle,
            orderId: orderId || null,
            purchased: true,
            purchasedAt: Date.now(),
            expiresAt: Date.now() + 1000 * 60 * 60 * 24 * 365
          })
        );
      } catch (error) {}
    }

    function hasStoredAccess() {
      var data = readAccess();
      if (!data || !data.email) return false;
      if (data.productHandle && productHandle && data.productHandle !== productHandle) return false;

      if (loggedInEmail) {
        return normalizeEmail(loggedInEmail) === normalizeEmail(data.email);
      }

      return true;
    }

    function unlockLessonContent() {
      var locked = document.querySelector('[data-lesson-access-locked]');
      var content = document.querySelector('[data-lesson-access-content]');

      if (locked) locked.hidden = true;
      if (content) content.hidden = false;
    }

    function unlockLessonMenu() {
      document.querySelectorAll('[data-lesson-menu-link]').forEach(function (link) {
        link.hidden = false;
      });
    }

    function persistAccessFromQuery() {
      var params = new URLSearchParams(window.location.search);
      if (params.get('kickstarter_purchased') !== '1') return false;

      var stored = readAccess();
      var email = loggedInEmail || (stored && stored.email) || '';
      var orderId = params.get('order_id') || (stored && stored.orderId) || null;

      if (email) {
        saveAccess(email, orderId);
      }

      params.delete('kickstarter_purchased');
      params.delete('order_id');
      var nextQuery = params.toString();
      var nextUrl = window.location.pathname + (nextQuery ? '?' + nextQuery : '');
      window.history.replaceState({}, document.title, nextUrl);

      return Boolean(email);
    }

    if (serverGrantedAccess) {
      if (loggedInEmail) {
        saveAccess(loggedInEmail, readAccess() && readAccess().orderId);
      }
      unlockLessonContent();
      unlockLessonMenu();
      return;
    }

    if (persistAccessFromQuery() || hasStoredAccess()) {
      unlockLessonContent();
      unlockLessonMenu();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lesson-page-content"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-lesson-page]');
    if (!root) return;

    const gridEl = root.querySelector('[data-lesson-grid]');
    const lessonsEl = root.querySelector('[data-lesson-lessons]');
    const panels = Array.from(root.querySelectorAll('[data-lesson-panel]'));
    const cards = Array.from(root.querySelectorAll('[data-lesson-card]'));
    const navTriggers = Array.from(root.querySelectorAll('[data-lesson-trigger]'));
    const introTriggers = Array.from(root.querySelectorAll('[data-lesson-intro]'));
    let activeIndex = Number(root.dataset.activeLesson || 0);

    const readLessonFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      const lessonParam = params.get('lesson');
      if (!lessonParam) return null;

      const lessonNumber = Number(lessonParam);
      if (!Number.isFinite(lessonNumber) || lessonNumber < 1) return null;

      return lessonNumber - 1;
    };

    const getCurrentLessonIndex = () => {
      const urlIndex = readLessonFromUrl();
      if (urlIndex !== null) return urlIndex;
      const datasetIndex = Number(root.dataset.activeLesson);
      return Number.isFinite(datasetIndex) ? datasetIndex : activeIndex;
    };

    const scrollLessonPageDown = () => {
      const isLessonView = root.dataset.lessonView === 'lesson';
      const offerCta = root.querySelector('.offer-cta');
      const activePanel = panels[activeIndex] || panels[0];
      let target = null;

      if (isLessonView && offerCta) {
        target = offerCta;
      } else if (isLessonView && activePanel) {
        target = activePanel;
      } else if (gridEl) {
        target = gridEl;
      }

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      window.scrollBy({ top: window.innerHeight * 0.85, behavior: 'smooth' });
    };

    const fetchVideoTitle = async (host, id) => {
      if (!id) return null;

      const oembedUrl =
        host === 'vimeo'
          ? 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + id)
          : 'https://www.youtube.com/oembed?url=' +
            encodeURIComponent('https://www.youtube.com/watch?v=' + id) +
            '&format=json';

      try {
        const response = await fetch(oembedUrl);
        if (!response.ok) return null;
        const data = await response.json();
        return data.title || null;
      } catch (error) {
        return null;
      }
    };

    const applyTitleForIndex = (index, title) => {
      if (!title) return;

      const panel = panels[index];
      if (panel) {
        const panelTitleEl = panel.querySelector('[data-lesson-card-title]');
        if (panelTitleEl) {
          panelTitleEl.textContent = title;
          panelTitleEl.classList.add('lesson-page__lesson-title--loaded');
        }
        panel.dataset.lessonTitle = title;
        const panelImage = panel.querySelector('.lesson-page__lesson-media-img');
        if (panelImage) panelImage.alt = title;
      }

      const card = cards[index];
      if (card) {
        const cardTitleEl = card.querySelector('[data-lesson-card-title]');
        if (cardTitleEl) {
          cardTitleEl.textContent = title;
          cardTitleEl.classList.add('lesson-page__card-title--loaded');
        }
        card.dataset.lessonTitle = title;
        const cardImage = card.querySelector('.lesson-page__card-img');
        if (cardImage) cardImage.alt = title;
      }

      const navTrigger = navTriggers.find((trigger) => Number(trigger.dataset.lessonTrigger) === index);
      if (navTrigger) {
        const navLabelEl = navTrigger.querySelector('[data-lesson-nav-label]');
        if (navLabelEl) navLabelEl.textContent = title;
        navTrigger.dataset.lessonTitle = title;
      }
    };

    const lessonSources = panels.length
      ? panels.map((panel, index) => ({
          index,
          host: panel.dataset.videoHost || 'youtube',
          id: panel.dataset.videoId,
          fallback:
            panel.dataset.lessonTitleFallback ||
            panel.dataset.lessonTitle ||
            navTriggers[index]?.dataset.lessonTitleFallback ||
            '',
        }))
      : cards.map((card) => ({
          index: Number(card.dataset.lessonIndex),
          host: card.dataset.videoHost || 'youtube',
          id: card.dataset.videoId,
          fallback: card.dataset.lessonTitleFallback || card.dataset.lessonTitle || '',
        }));

    lessonSources.forEach((source) => {
      if (!source.id) {
        if (source.fallback) applyTitleForIndex(source.index, source.fallback);
        return;
      }

      fetchVideoTitle(source.host, source.id).then((fetchedTitle) => {
        applyTitleForIndex(source.index, fetchedTitle || source.fallback);
      });
    });

    const setViewMode = (mode) => {
      root.classList.toggle('lesson-page--grid', mode === 'grid');
      root.classList.toggle('lesson-page--lesson', mode === 'lesson');
      root.dataset.lessonView = mode;

      if (lessonsEl) {
        if (mode === 'lesson') {
          lessonsEl.hidden = false;
        } else {
          lessonsEl.hidden = true;
        }
      }
    };

    const resetPanelPlayer = (panel) => {
      const player = panel.querySelector('[data-lesson-player]');
      const trigger = panel.querySelector('[data-lesson-play-trigger]');
      const embed = panel.querySelector('[data-lesson-embed]');
      if (!trigger || !embed) return;

      embed.innerHTML = '';
      embed.hidden = true;
      trigger.hidden = false;
      if (player) player.classList.remove('is-playing');
    };

    const playPanelVideo = (panel) => {
      const videoId = panel.dataset.videoId;
      const videoHost = panel.dataset.videoHost || 'youtube';
      const player = panel.querySelector('[data-lesson-player]');
      const trigger = panel.querySelector('[data-lesson-play-trigger]');
      const embed = panel.querySelector('[data-lesson-embed]');
      if (!videoId || !trigger || !embed) return;

      const lessonTitle = (panel.dataset.lessonTitle || 'Lesson video').replace(/"/g, '&quot;');
      const embedSrc =
        videoHost === 'vimeo'
          ? 'https://player.vimeo.com/video/' + encodeURIComponent(videoId) + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?rel=0&autoplay=1';

      embed.innerHTML =
        '<iframe src="' +
        embedSrc +
        '" title="' +
        lessonTitle +
        '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';

      trigger.hidden = true;
      embed.hidden = false;
      if (player) player.classList.add('is-playing');
    };

    const setIntroActive = (isActive) => {
      introTriggers.forEach((trigger) => {
        trigger.classList.toggle('lesson-page__nav-link--active', isActive);
      });
    };

    const updateNavState = (index) => {
      setIntroActive(false);

      navTriggers.forEach((trigger) => {
        const triggerIndex = Number(trigger.dataset.lessonTrigger);
        const isActive = triggerIndex === index;

        trigger.classList.toggle('lesson-page__nav-link--active', isActive);
        trigger.classList.remove('lesson-page__nav-link--locked');
        trigger.removeAttribute('aria-disabled');
      });
    };

    const updateLessonUrl = (index) => {
      const params = new URLSearchParams(window.location.search);
      const lessonNumber = index + 1;
      params.set('lesson', String(lessonNumber));
      const nextUrl = window.location.pathname + '?' + params.toString();
      window.history.replaceState({ lesson: lessonNumber }, '', nextUrl);
    };

    const clearLessonUrl = () => {
      const nextUrl = window.location.pathname;
      window.history.replaceState({}, '', nextUrl);
    };

    const ensureResourceLink = (panel, index) => {
      if (!panel) return;

      const card = cards[index];
      const resourceUrl = panel.dataset.lessonResourceUrl || card?.dataset.lessonResourceUrl;
      const lessonCard = panel.querySelector('.lesson-page__lesson-card');
      if (!lessonCard) return;

      const existingLink = panel.querySelector('.lesson-page__lesson-resource');
      if (!resourceUrl) {
        if (existingLink) existingLink.remove();
        return;
      }

      const resourceLabel =
        panel.dataset.lessonResourceLabel ||
        card?.dataset.lessonResourceLabel ||
        'Download PDF Resources';

      let resourceLink = existingLink;
      if (!resourceLink) {
        resourceLink = document.createElement('a');
        resourceLink.className = 'lesson-page__lesson-resource';
        resourceLink.innerHTML =
          '<span class="lesson-page__lesson-resource-icon" aria-hidden="true">' +
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M9 2.25V11.25M9 11.25L5.625 7.875M9 11.25L12.375 7.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '<path d="M3.375 13.5H14.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>' +
          '</svg></span>' +
          '<span class="lesson-page__lesson-resource-label"></span>';
        lessonCard.appendChild(resourceLink);
      }

      resourceLink.href = resourceUrl;
      if (resourceUrl.toLowerCase().includes('.pdf')) {
        resourceLink.setAttribute('download', '');
      } else {
        resourceLink.removeAttribute('download');
      }

      const labelEl = resourceLink.querySelector('.lesson-page__lesson-resource-label');
      if (labelEl) labelEl.textContent = resourceLabel;
    };

    const setActiveLesson = (index, options) => {
      const opts = options || {};
      if (!panels.length) return;

      const maxIndex = panels.length - 1;
      const nextIndex = Math.max(0, Math.min(index, maxIndex));

      panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === nextIndex;
        panel.classList.toggle('lesson-page__lesson--hidden', !isActive);
        if (!isActive) {
          resetPanelPlayer(panel);
        }
      });

      activeIndex = nextIndex;
      root.dataset.activeLesson = String(nextIndex);
      updateNavState(nextIndex);

      if (opts.updateUrl !== false) {
        updateLessonUrl(nextIndex);
      }

      const activePanel = panels[nextIndex];
      ensureResourceLink(activePanel, nextIndex);
      const activeTitle = activePanel?.querySelector('.lesson-page__lesson-title');
      if (activeTitle) {
        root.querySelectorAll('.lesson-page__lesson-title').forEach((titleEl) => {
          titleEl.removeAttribute('id');
        });
        activeTitle.setAttribute('id', 'lesson-page-active-title');
      }
    };

    const enterLessonView = (index, options) => {
      setViewMode('lesson');
      setActiveLesson(index, options);
    };

    const enterGridView = (options) => {
      const opts = options || {};
      setViewMode('grid');
      panels.forEach((panel) => resetPanelPlayer(panel));
      navTriggers.forEach((trigger) => {
        trigger.classList.remove('lesson-page__nav-link--active');
      });
      setIntroActive(true);
      if (opts.updateUrl !== false) {
        clearLessonUrl();
      }
    };

    panels.forEach((panel) => {
      const playTrigger = panel.querySelector('[data-lesson-play-trigger]');
      if (playTrigger) {
        playTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          playPanelVideo(panel);
        });
      }
    });

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const index = Number(card.dataset.lessonIndex);
        if (!Number.isFinite(index)) return;
        enterLessonView(index);
      });
    });

    introTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        enterGridView();
      });
    });

    navTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const index = Number(trigger.dataset.lessonTrigger);
        if (!Number.isFinite(index)) return;
        enterLessonView(index);
      });
    });

    root.addEventListener('click', (event) => {
      if (!event.target.closest('[data-lesson-next]')) return;
      event.preventDefault();
      scrollLessonPageDown();
    });

    const urlLessonIndex = readLessonFromUrl();

    // Default: show all lesson cards in the grid. Only open a single lesson when ?lesson=N is in the URL.
    if (urlLessonIndex !== null) {
      enterLessonView(urlLessonIndex, { updateUrl: false });
    } else {
      enterGridView({ updateUrl: false });
    }

    window.addEventListener('popstate', () => {
      const index = readLessonFromUrl();
      if (index !== null) {
        enterLessonView(index, { updateUrl: false });
      } else {
        enterGridView({ updateUrl: false });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["library-page-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const shell = document.querySelector('.js-library-shell')
    if (!shell) return

    const searchInput = shell.querySelector('.js-library-search')
    const filterButtons = [...shell.querySelectorAll('.library-page__filters button[data-filter]')]
    const cards = [...shell.querySelectorAll('.library-card:not(.library-card--empty)')]
    const noResults = shell.querySelector('.js-library-no-results')

    if (!searchInput || !filterButtons.length || !cards.length) return

    const filterMatchers = {
      all: () => true,
      ebooks: (type, typeLabel) =>
        type.includes('ebook') || type.includes('e-book') || typeLabel.includes('ebook') || typeLabel.includes('e-book'),
      templates: (type, typeLabel) => type.includes('template') || typeLabel.includes('template'),
      'video-bundles': (type, typeLabel) =>
        type.includes('video') ||
        type.includes('bundle') ||
        typeLabel.includes('video') ||
        typeLabel.includes('bundle'),
      'social-media-kits': (type, typeLabel) =>
        type.includes('social') ||
        type.includes('media') ||
        type.includes('kit') ||
        typeLabel.includes('social') ||
        typeLabel.includes('media') ||
        typeLabel.includes('kit')
    }

    let activeFilter = 'all'

    const applyFilters = () => {
      const query = searchInput.value.trim().toLowerCase()
      let visibleCount = 0

      cards.forEach((card) => {
        const title = card.dataset.productTitle || ''
        const type = card.dataset.productType || ''
        const typeLabel = card.dataset.productTypeLabel || ''
        const matcher = filterMatchers[activeFilter] || filterMatchers.all
        const matchesFilter = matcher(type, typeLabel)
        const matchesSearch =
          query === '' || title.includes(query) || type.includes(query) || typeLabel.includes(query)
        const isVisible = matchesFilter && matchesSearch

        card.hidden = !isVisible
        card.style.display = isVisible ? '' : 'none'

        if (isVisible) visibleCount += 1
      })

      if (noResults) {
        const showEmptyState = visibleCount === 0
        noResults.hidden = !showEmptyState
        noResults.style.display = showEmptyState ? '' : 'none'
      }
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.filter || 'all'
        filterButtons.forEach((item) => item.classList.remove('is-active'))
        button.classList.add('is-active')
        applyFilters()
      })
    })

    searchInput.addEventListener('input', applyFilters)
    searchInput.addEventListener('search', applyFilters)
    applyFilters()
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pricing-plans-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function parseCatalog(root) {
      var cid = root.getAttribute('data-pricing-plan-catalog-id');
      if (!cid) return null;
      var el = document.getElementById('PricingPlanCatalog-' + cid);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    function getCatalogEntry(root, catalog, el) {
      if (!catalog || !Array.isArray(catalog) || !el) return null;
      var article = el.closest('article[data-pricing-plan-block-id]');
      if (!article) return null;
      var blockId = article.getAttribute('data-pricing-plan-block-id');
      return catalog.find(function (p) {
        return p.block_id === blockId;
      });
    }

    function initPricingPlanSection(root) {
      if (root.getAttribute('data-pricing-plan-section-init') === '1') return;

      var persistOn = root.getAttribute('data-pricing-plan-persist') === 'true';
      var saveUrl = (root.getAttribute('data-pricing-plan-save-url') || '').trim();
      var catalog = persistOn ? parseCatalog(root) : null;
      var canPersist = persistOn && saveUrl && catalog && Array.isArray(catalog);
      var hasCheckoutForm = !!root.querySelector('form.pricing-card__checkout-form');

      if (!canPersist && !hasCheckoutForm) return;

      root.setAttribute('data-pricing-plan-section-init', '1');

      if (canPersist) {
        root.addEventListener(
          'click',
          function (e) {
            var link = e.target.closest('a.pricing-card__button');
            if (!link || !root.contains(link)) return;
            if (root.getAttribute('data-pricing-plan-customer-logged-in') !== 'true') return;

            var entryOnly = getCatalogEntry(root, catalog, link);
            if (!entryOnly) return;

            e.preventDefault();
            var collectionFallback =
              (root.getAttribute('data-pricing-plan-fallback-url') || '').trim() || '/collections/all';
            var rawHref = (link.getAttribute('href') || '').trim();
            var payloadOnly = {
              plan_handle: entryOnly.plan_handle,
              plan_name: entryOnly.name,
              price_display: entryOnly.price_amount,
              features: entryOnly.features,
              block_id: entryOnly.block_id,
              source: 'pricing_plans',
            };

            fetch(saveUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payloadOnly),
              credentials: 'same-origin',
              keepalive: true,
            })
              .catch(function () {})
              .finally(function () {
                var dest = rawHref;
                if (!dest || dest === '#' || dest === '#top') {
                  dest = collectionFallback;
                }
                if (dest) {
                  window.location.assign(dest);
                }
              });
          },
          false
        );
      }

      if (canPersist && hasCheckoutForm) {
        root.addEventListener(
          'submit',
          function (e) {
            var form = e.target;
            if (!(form instanceof HTMLFormElement)) return;
            if (!form.classList.contains('pricing-card__checkout-form') || !root.contains(form)) return;
            if (root.getAttribute('data-pricing-plan-customer-logged-in') !== 'true') return;

            var el = e.submitter instanceof HTMLElement ? e.submitter : form.querySelector('button[type="submit"]');
            var entry = getCatalogEntry(root, catalog, el || form);
            if (!entry) return;

            e.preventDefault();
            var payload = {
              plan_handle: entry.plan_handle,
              plan_name: entry.name,
              price_display: entry.price_amount,
              features: entry.features,
              block_id: entry.block_id,
              source: 'pricing_plans',
            };
            fetch(saveUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload),
              credentials: 'same-origin',
              keepalive: true,
            })
              .catch(function () {})
              .finally(function () {
                HTMLFormElement.prototype.submit.call(form);
              });
          },
          false
        );
      }
    }

    function boot() {
      document.querySelectorAll('.pricing-plans.full-width').forEach(function (root) {
        initPricingPlanSection(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad2(n) {
      return String(n).padStart(2, '0');
    }

    function parseOffsetMinutes(offsetStr) {
      const value = String(offsetStr || '').trim();
      let match = /^([+-])(\d{2})(\d{2})$/.exec(value);
      if (match) {
        return (match[1] === '+' ? 1 : -1) * (parseInt(match[2], 10) * 60 + parseInt(match[3], 10));
      }
      match = /^([+-])(\d{2}):(\d{2})$/.exec(value);
      if (match) {
        return (match[1] === '+' ? 1 : -1) * (parseInt(match[2], 10) * 60 + parseInt(match[3], 10));
      }
      match = /^([+-])(\d{1,2})$/.exec(value);
      if (match) {
        return (match[1] === '+' ? 1 : -1) * parseInt(match[2], 10) * 60;
      }
      return NaN;
    }

    function wallClockToUtcMs(datePart, timePart, offsetStr) {
      if (!datePart || !timePart) return NaN;

      const offsetMinutes = parseOffsetMinutes(offsetStr);
      if (!Number.isFinite(offsetMinutes)) return NaN;

      const dateBits = datePart.split('-').map(Number);
      const timeBits = timePart.split(':').map(Number);
      if (dateBits.length < 3 || timeBits.length < 2) return NaN;

      const year = dateBits[0];
      const month = dateBits[1];
      const day = dateBits[2];
      const hour = timeBits[0] || 0;
      const minute = timeBits[1] || 0;
      const second = timeBits[2] || 0;

      return Date.UTC(year, month - 1, day, hour, minute, second) - offsetMinutes * 60 * 1000;
    }

    document.querySelectorAll('[data-product-offer]').forEach(function (root) {
      const hEl = root.querySelector('[data-offer-timer-h]');
      const mEl = root.querySelector('[data-offer-timer-m]');
      const sEl = root.querySelector('[data-offer-timer-s]');
      const countdown = root.querySelector('[data-offer-countdown]');
      const offerWrap = root;
      if (!hEl || !mEl || !sEl || !countdown) return;

      const endMs = wallClockToUtcMs(
        root.dataset.offerDate,
        root.dataset.offerTime,
        root.dataset.shopOffset
      );

      if (!Number.isFinite(endMs)) {
        offerWrap.hidden = true;
        return;
      }

      function tick() {
        const diff = endMs - Date.now();
        if (diff <= 0) {
          hEl.textContent = '00';
          mEl.textContent = '00';
          sEl.textContent = '00';
          offerWrap.hidden = true;
          return;
        }
        const totalS = Math.floor(diff / 1000);
        const sec = totalS % 60;
        const totalM = Math.floor(totalS / 60);
        const min = totalM % 60;
        const hr = Math.floor(totalM / 60);
        hEl.textContent = pad2(Math.min(hr, 99));
        mEl.textContent = pad2(min);
        sEl.textContent = pad2(sec);
      }

      tick();
      setInterval(tick, 1000);
    });
  })();

  (function () {
    function toInt(value, fallback) {
      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? fallback : parsed;
    }

    function randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const counters = Array.from(document.querySelectorAll('[data-live-counter]'));
    const liveStatsScript = document.querySelector('script[data-live-stats-config]');
    let liveStatsConfig = null;

    if (liveStatsScript && liveStatsScript.textContent) {
      try {
        liveStatsConfig = JSON.parse(liveStatsScript.textContent.trim());
      } catch (e) {
        liveStatsConfig = null;
      }
    }

    counters.forEach(function (el) {
      const rawText = (el.textContent || '').trim();
      const match = rawText.match(/^(\d+)\s+(.+)$/);
      if (!match) return;

      let current = toInt(match[1], 0);
      const suffix = match[2];
      const min = toInt(el.dataset.liveCounterMin, Math.max(0, current - 3));
      const max = toInt(el.dataset.liveCounterMax, current + 8);
      const intervalMin = toInt(el.dataset.liveCounterIntervalMinMs, 4000);
      const intervalMax = toInt(el.dataset.liveCounterIntervalMaxMs, 9000);
      const type = (el.dataset.liveCounterType || '').trim();

      function render() {
        el.textContent = current + ' ' + suffix;
      }

      if (!(liveStatsConfig && liveStatsConfig.endpoint)) {
        if (type === 'checkout') {
          const viewingCounter = counters.find(function (item) {
            return item.dataset.liveCounterType === 'viewing';
          });
          const viewingMatch = viewingCounter ? (viewingCounter.textContent || '').trim().match(/^(\d+)\s+/) : null;
          const viewingValue = viewingMatch ? toInt(viewingMatch[1], max) : max;
          const guardedMax = Math.max(min, Math.min(max, Math.max(min, viewingValue - 1)));
          current = randomInt(min, guardedMax);
        } else {
          current = randomInt(min, max);
        }
      }

      function getStorageKey(counterType) {
        return 'plr-live-counter-' + counterType;
      }

      function getReloadIncrementValue(counterType, lowerBound, upperBound, fallbackValue) {
        const key = getStorageKey(counterType || 'default');
        const previous = toInt(window.localStorage.getItem(key), fallbackValue);
        const next = previous >= upperBound ? lowerBound : previous + 1;
        window.localStorage.setItem(key, String(next));
        return next;
      }

      if (!(liveStatsConfig && liveStatsConfig.endpoint)) {
        if (type === 'checkout') {
          const viewingCounter = counters.find(function (item) {
            return item.dataset.liveCounterType === 'viewing';
          });
          const viewingMatch = viewingCounter ? (viewingCounter.textContent || '').trim().match(/^(\d+)\s+/) : null;
          const viewingValue = viewingMatch ? toInt(viewingMatch[1], max) : max;
          const guardedMax = Math.max(min, Math.min(max, Math.max(min, viewingValue - 1)));
          current = getReloadIncrementValue(type, min, guardedMax, current);
        } else {
          current = getReloadIncrementValue(type, min, max, current);
        }
      }

      render();
    });

    if (liveStatsConfig && liveStatsConfig.endpoint) {
      const endpoint = String(liveStatsConfig.endpoint).trim();
      const productId = liveStatsConfig.productId;
      const viewingCounter = counters.find(function (item) {
        return item.dataset.liveCounterType === 'viewing';
      });
      const checkoutCounter = counters.find(function (item) {
        return item.dataset.liveCounterType === 'checkout';
      });

      if (endpoint && viewingCounter && checkoutCounter) {
        function updateCounter(counterEl, value) {
          const text = (counterEl.textContent || '').trim();
          const suffixMatch = text.match(/^\d+\s+(.+)$/);
          if (!suffixMatch) return;

          counterEl.dataset.liveCounterReal = 'true';
          counterEl.textContent = String(value) + ' ' + suffixMatch[1];
        }

        function fetchLiveStats() {
          const separator = endpoint.indexOf('?') === -1 ? '?' : '&';
          const url = endpoint + separator + 'product_id=' + encodeURIComponent(String(productId));

          fetch(url, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
            credentials: 'same-origin',
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Live stats request failed');
              return response.json();
            })
            .then(function (payload) {
              if (!payload || typeof payload !== 'object') return;

              const viewing = Number.parseInt(payload.viewing, 10);
              const checkout = Number.parseInt(payload.checkout, 10);
              if (Number.isNaN(viewing) || Number.isNaN(checkout)) return;

              updateCounter(viewingCounter, Math.max(0, viewing));
              updateCounter(checkoutCounter, Math.max(0, Math.min(checkout, viewing)));
            })
            .catch(function () {
              // Keep fallback simulated numbers when endpoint is unavailable.
            });
        }

        fetchLiveStats();
        window.setInterval(fetchLiveStats, 15000);
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["site-header-cart-drawer"] && !Shopify.designMode) return;
  try {
    const CART_UPDATE_EVENT = 'cart:update';

  /**
   * @param {number} itemCount
   */
  function updateSiteHeaderCartCount(itemCount) {
    document.querySelectorAll('[data-header-cart-count]').forEach((badge) => {
      if (!(badge instanceof HTMLElement)) return;

      const hasItems = itemCount > 0;
      badge.classList.toggle('hidden', !hasItems);
      badge.textContent = hasItems ? (itemCount < 100 ? String(itemCount) : '99+') : '';
    });
  }

  document.addEventListener(CART_UPDATE_EVENT, (event) => {
    if (!(event instanceof CustomEvent)) return;

    const itemCount = event.detail?.data?.itemCount;
    if (typeof itemCount !== 'number') return;

    updateSiteHeaderCartCount(itemCount);
  });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-header-cart-count]').forEach((badge) => {
      if (!(badge instanceof HTMLElement)) return;
      const count = parseInt(badge.textContent ?? '0', 10) || 0;
      badge.classList.toggle('hidden', count === 0);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
